import React from 'react';
import Icon from '@ant-design/icons';
import { theme } from 'antd';

const Profile = () => {
  const { token } = theme.useToken();
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 0.0308838C4.79086 0.0308838 3 1.82174 3 4.03088C3 6.24002 4.79086 8.03088 7 8.03088C9.20914 8.03088 11 6.24002 11 4.03088C11 1.82174 9.20914 0.0308838 7 0.0308838ZM4 4.03088C4 2.37403 5.34315 1.03088 7 1.03088C8.65685 1.03088 10 2.37403 10 4.03088C10 5.68774 8.65685 7.03088 7 7.03088C5.34315 7.03088 4 5.68774 4 4.03088ZM2.00873 9.03088C0.903151 9.03088 0 9.91776 0 11.0309C0 12.7221 0.83281 13.9972 2.13499 14.8275C3.41697 15.6449 5.14526 16.0309 7 16.0309C8.85474 16.0309 10.583 15.6449 11.865 14.8275C13.1672 13.9972 14 12.7221 14 11.0309C14 9.92645 13.1045 9.03089 12 9.03089L2.00873 9.03088ZM1 11.0309C1 10.4776 1.44786 10.0309 2.00873 10.0309L12 10.0309C12.5522 10.0309 13 10.4787 13 11.0309C13 12.3397 12.3777 13.3146 11.3274 13.9843C10.2568 14.6669 8.73511 15.0309 7 15.0309C5.26489 15.0309 3.74318 14.6669 2.67262 13.9843C1.62226 13.3146 1 12.3397 1 11.0309Z"
        fill={token.colorPPrimary}
      />
    </svg>
  );
};

const ProfileIcon = (props) => <Icon component={Profile} {...props} />;

export default ProfileIcon;
